import { RECAPTCHA, SERVICES, SYSTEM } from '../../../util/constants';
import logger from '../../../util/logging.client';
import { API_VALIDATION_ERROR_MESSAGES } from '../errorMessages';
import { getUserNameOtc } from './loginVerification.api';

const { V2, V3 } = RECAPTCHA;
const { EIR } = SYSTEM;
const { DUALPLAY, DUALPLAY_PSTN, SA_PSTN, DUALPLAY_NBI, MOBILE } = SERVICES;
const { invalidRecaptcha, ivalidCredentials, invalidLogin, mobileOnlyCustomer, genericError } =
  API_VALIDATION_ERROR_MESSAGES;
/**
 * @name getUsernameOTCInfo
 * @description Fetches data from the GRAPHQL API
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {string} recaptchaV3Token - recaptcha version 3 token
 * @param {string} email - User input emailId
 * @param {number} password - User input password
 * @param {string} captchaV2 - recaptcha version 3 token
 * @param {string} setEnableCaptchaV2 - Enables recaptcha version 2 if v3 fails
 * @param {string} setApiError - Set the value fo api error
 * @param {string} setDisableCTA - Enables or disables CTA
 * @param {string} showMobileSupportModal - Toggles mobile support modal
 * @param {string} showLoginVerificationModal - Toggles mobile login verification modal
 * @param {string} showBroadbandSupportModal - Toggles broadband support modal
 * @param {string} showEirSupportModal - Toggles eir support modal
 * @param {string} setSweeprParams - set the values for sweepr launch
 * @returns {Promise<void>} Promise and sets the state clientSideGRAPHQL when resolved
 */
export const getUsernameOTCInfo = async (
  graphql,
  recaptchaV3Token,
  email,
  password,
  captchaV2,
  setEnableCaptchaV2,
  setApiError,
  setDisableCTA,
  showMobileSupportModal,
  showLoginVerificationModal,
  showBroadbandSupportModal,
  showEirSupportModal,
  setSweeprParams,
) => {
  try {
    const variables = {
      userName: email,
      password,
      systemId: EIR,
      recaptcha: captchaV2?.login || recaptchaV3Token,
      recaptchaVersion: captchaV2?.login ? V2 : V3,
    };
    setSweeprParams(prev => ({ ...prev, OTC: null }));
    const data = await getUserNameOtc(graphql, variables);
    if (data) {
      setApiError(prev => ({
        ...prev,
        invalidLogin: false,
        invalidAccount: false,
        errorMessage: null,
      }));
    }
    if (data?.userNameOtc?.isR6) {
      showEirSupportModal.enable();
      showLoginVerificationModal.disable();
    } else if (data?.userNameOtc?.isION) {
      if (
        data?.userNameOtc?.ionServices?.includes(DUALPLAY) ||
        data?.userNameOtc?.ionServices?.includes(DUALPLAY_PSTN) ||
        data?.userNameOtc?.ionServices?.includes(SA_PSTN)
      ) {
        setSweeprParams(prev => ({ ...prev, OTC: data?.userNameOtc?.onetimecode }));
        // showLoginVerificationModal.disable();
      } else if (data?.userNameOtc?.ionServices?.includes(DUALPLAY_NBI)) {
        showBroadbandSupportModal.enable();
        showLoginVerificationModal.disable();
      } else if (data?.userNameOtc?.ionServices?.includes(MOBILE)) {
        showMobileSupportModal.enable();
        showLoginVerificationModal.disable();
      }
    }
    return data;
  } catch (error) {
    if (error.message.includes(invalidRecaptcha)) {
      setEnableCaptchaV2({ login: true, account: false });
      setDisableCTA(true);
    } else if (error.message.includes(mobileOnlyCustomer)) {
      showMobileSupportModal.enable();
      showLoginVerificationModal.disable();
    } else if (error.message.includes(ivalidCredentials)) {
      setEnableCaptchaV2({ login: false, account: false });
      setApiError(prev => ({
        ...prev,
        invalidLogin: true,
        invalidAccount: false,
        errorMessage: invalidLogin,
      }));
      setDisableCTA(true);
    } else {
      setApiError(prev => ({
        ...prev,
        invalidLogin: true,
        invalidAccount: false,
        errorMessage: genericError,
      }));
      setDisableCTA(true);
    }
    logger.log('error', 'Error executing userNameOTC:', error);
    return error;
  }
};
